export default "__VITE_ASSET__DygglHXM__"